/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ i: NonNullable<unknown> }} Average_Inertia_ValueInputs */



/**
* | output |
* | --- |
* | "- Average inertia: {i} min/°C" |
*
* @param {Average_Inertia_ValueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const average_inertia_value = /** @type {((inputs: Average_Inertia_ValueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Average_Inertia_ValueInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`- Average inertia: ${i?.i} min/°C`)
	return /** @type {LocalizedString} */ (`- Inertie moyenne: ${i?.i} min/°C`)
});